const getDatesRange = {
    data() {
        return {
            monthNames: ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December",
            ],
            fullWeekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        };
    },
    methods: {
        getDatesRange(startDate, stopDate = "", returnTime = false) {
            Date.prototype.addDays = function (days) {
                const date = new Date(this.valueOf());
                date.setDate(date.getDate() + days);
                return date;
            };

            const dateArray = [];
            let currentDate = startDate;

            if (stopDate !== "") {
                while (currentDate <= stopDate) {
                    if (returnTime) {
                        const time = new Date(currentDate.setHours(0, 0, 0, 0));
                        dateArray.push(time.getTime());
                    } else {
                        const time2 = new Date(currentDate.setHours(0, 0, 0, 0));
                        dateArray.push(time2);
                    }
                    currentDate = currentDate.addDays(1);
                }
            }

            if (stopDate === "") {
                const time = new Date(currentDate.setHours(0, 0, 0, 0));
                if (returnTime) {
                    dateArray.push(time.getTime());
                } else {
                    dateArray.push(time);
                }
            }

            return dateArray;
        },

        getDetailsDateRange(start, end) {
            const dateRange = this.getDatesRange(start, end);

            return this.getDetailsFromDateRange(dateRange);
        },

        getDetailsFromDateRange(dateRange) {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December",
            ];

            const fullWeekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

            return dateRange.map((d) => ({
                date: d.getDate(),
                month: monthNames[d.getMonth()],
                year: d.getFullYear(),
                weekday: fullWeekdays[d.getDay()],
                data: d,
                time: d.getTime(),
            }));
        },

        getDateForNextWeekDayInRange(weekday, start, end) {
            const now = new Date(start);

            const nextEvt = new Date(+now);
            nextEvt.setHours(0, 0, 0, 0);

            while (nextEvt.getDay() !== weekday && nextEvt.getTime() < end.getTime()) {
                nextEvt.setDate(nextEvt.getDate() + 1);
            }

            return nextEvt;
        },

        getLastWeekDayInRange(weekday, start, end) {
            const now = new Date(end);

            const nextEvt = new Date(+now);
            nextEvt.setHours(0, 0, 0, 0);

            while (nextEvt.getDay() !== weekday && nextEvt.getTime() > start.getTime()) {
                nextEvt.setDate(nextEvt.getDate() - 1);
            }

            return nextEvt;
        },
    },
};

export default getDatesRange;
